import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";

export const dictionary = () => {
  const desc = FindLangKey("general-public-label-description");
  const traceId = FindLangKey("general-public-tracking-code");
  const price = FindLangKey("freeze-contracts-label-price");
  const previewMsg = FindLangKey("general-public-preview");
  const deleteMsg = FindLangKey("general-public-label-delete");
  return { desc, traceId, price, previewMsg, deleteMsg };
};
